import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

function FileImportDetails({ fileId }) {
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fileId) {
      setFile(null);
      setErrors([]);
      return;
    }

    setLoading(true);
    fetch(`/api/files/${fileId}/import-errors`)
      .then((res) => res.json())
      .then((data) => {
        setFile(data.file || null);
        setErrors(data.errors || []);
      })
      .catch((err) => {
        console.error("Error fetching file import details:", err);
        setFile(null);
        setErrors([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [fileId]);

  if (!fileId) return null;

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Import Details
      </Typography>

      {loading && <Typography>Loading import details...</Typography>}

      {!loading && (
        <Box display="flex" flexDirection="column" gap={1.5}>
          <Typography>
            <strong>Import Summary:</strong> {file?.import_summary || "—"}
          </Typography>
          <Typography>
            <strong>File Error:</strong> {file?.errorMessage || "—"}
          </Typography>
          <Typography>
            <strong>Last Import Error At:</strong>{" "}
            {file?.last_error_at ? new Date(file.last_error_at).toLocaleString() : "—"}
          </Typography>

          {errors.length > 0 ? (
            <>
              <Alert severity="warning">
                {errors.length} row import error{errors.length === 1 ? "" : "s"} recorded for this file.
              </Alert>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Row</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Brand</TableCell>
                    <TableCell>Error</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {errors.map((error) => (
                    <TableRow key={error.id}>
                      <TableCell>{error.csv_row_number || "—"}</TableCell>
                      <TableCell>{error.email || "—"}</TableCell>
                      <TableCell>{error.brand || "—"}</TableCell>
                      <TableCell>{error.error_message}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </>
          ) : (
            <Alert severity="info">No row-level import errors recorded for this file.</Alert>
          )}
        </Box>
      )}
    </Paper>
  );
}

export default FileImportDetails;
